import { useMutation, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { queryClient, trpc } from "../../app/trpc.js";
import { Badge, Button, Card, FormRow, Input, MenuRow, Notice, PageTitle, Sheet, Spinner } from "../../ui/index.js";
import { type BackState, useCabinet } from "../cabinet/index.js";

/** Мастера салона: список, добавить; нажатие открывает график, услуги, отгулы мастера. Только владелец. */
export function MastersPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const cab = useCabinet();
  const list = useQuery(trpc.calendar.masters.list.queryOptions({ salonId: cab.salonId, includeInactive: true }));
  const [name, setName] = useState<string | null>(null);
  const save = useMutation(
    trpc.calendar.masters.save.mutationOptions({
      onSuccess: (m) => {
        void queryClient.invalidateQueries(trpc.calendar.masters.pathFilter());
        setName(null);
        navigate(`${cab.base}/settings/masters/${m.id}`);
      },
    }),
  );

  return (
    <div className="lg:max-w-3xl">
      <PageTitle>{t("masters.title")}</PageTitle>
      {list.isPending && <Spinner />}
      {list.data?.length === 0 && <Notice>{t("masters.empty")}</Notice>}
      {list.data && list.data.length > 0 && (
        <Card className="py-1">
          {list.data.map((m) => (
            <MenuRow
              key={m.id}
              title={m.name}
              right={m.active ? undefined : <Badge>{t("masters.off")}</Badge>}
              onClick={() => navigate(`${cab.base}/settings/masters/${m.id}`, { state: { backTo: "settings/masters" } satisfies BackState })}
            />
          ))}
        </Card>
      )}
      <Button className="mt-4 w-full lg:w-auto" onClick={() => setName("")}>
        {t("masters.add")}
      </Button>
      <Sheet open={name !== null} onClose={() => setName(null)} title={t("masters.add")}>
        <div className="space-y-3">
          <FormRow label={t("masters.name")} htmlFor="ms-name">
            <Input id="ms-name" value={name ?? ""} onChange={(e) => setName(e.target.value)} />
          </FormRow>
          {save.isError && <Notice kind="error">{t("common.error")}</Notice>}
          <Button
            className="w-full"
            disabled={!name?.trim() || save.isPending}
            onClick={() => save.mutate({ salonId: cab.salonId, name: (name ?? "").trim() })}
          >
            {t("settings.save")}
          </Button>
        </div>
      </Sheet>
    </div>
  );
}
